import { Modal, Form, Input, Button, Popconfirm } from "antd";
import { useDispatch } from "react-redux";
import notification from "../../global/openNotification";
import { createClientType, deleteClientType, updateClientType } from "store";
import useCheckPermission from "hooks/useCheckPermission";
import errorMessagesDescription from "components/mnl/global/errorMessagesDescription";
import { useCallback, useEffect, useState } from "react";

const CreateUpdateClientType = (props) => {
  const {
    handleCancel,
    openCreateUpdate,
    handleSubmit,
    isForUpdate,
    idForUpdate,
  } = props;

  const { handleVerifyPermission } = useCheckPermission();
  const accessRightsToDelete = handleVerifyPermission(
    "Administration:ClientType:Delete"
  );

  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  const LoadUpdateData = useCallback(() => {
    form.setFieldsValue({
      typeName: idForUpdate.typeName,
    });
  }, [form, idForUpdate]);

  useEffect(() => {
    if (isForUpdate) {
      LoadUpdateData();
    }
  }, [isForUpdate, LoadUpdateData]);

  const onFinish = (values) => {
    if (isForUpdate) {
      if (
        updateClientType.pending().type ===
        "clientTypes/update-client-type/pending"
      ) {
        setLoading(true);
      }
      dispatch(updateClientType([idForUpdate.id, values])).then((val) => {
        if (val.type === "clientTypes/update-client-type/fulfilled") {
          handleSubmit();
          setLoading(false);
          notification.success({
            message: "Updated Client Type",
            description: `Successfully updated ${values.typeName}`,
          });
        }
      });
    } else {
      if (
        createClientType.pending().type ===
        "clientTypes/create-client-type/pending"
      ) {
        setLoading(true);
      }
      dispatch(createClientType(values)).then((val) => {
        if (val.payload?.success) {
          handleSubmit();
          setLoading(false);
          notification.success({
            message: "Created Client Type",
            description: `Successfully created ${values.typeName}`,
          });
        }
        if (!val.payload?.success) {
          setLoading(false);
          notification.error({
            message: "Failed to Create Client Type",
            description: errorMessagesDescription(
              val.payload?.response?.data.errorMessages
            ),
          });
        }
      });
    }
  };

  const onFinishFailed = (errorInfo) => {
    // eslint-disable-next-line
    errorInfo.errorFields.map((item) => {
      notification.error({
        message: "Required Field",
        description: item?.errors[0].props.children,
      });
    });
  };

  const handleClickDelete = () => {
    //HANDLE LOADING
    if (
      deleteClientType.pending().type ===
      "clientTypes/delete-client-type/pending"
    ) {
      setLoading(true);
    }
    dispatch(deleteClientType(idForUpdate.id)).then((val) => {
      if (val.payload?.success) {
        handleSubmit();
        setLoading(false);
        notification.success({
          message: "Deleted Client Type",
          description: `Successfully deleted ${idForUpdate.typeName}`,
        });
      }
      if (!val.payload?.success) {
        setLoading(false);
        notification.error({
          message: "Failed to Delete Client Type",
          description: errorMessagesDescription(
            val.payload?.response?.data.errorMessages
          ),
        });
      }
    });
  };

  return (
    <Modal
      open={openCreateUpdate}
      title={isForUpdate ? "Update Client Type" : "Create Client Type"}
      onCancel={handleCancel}
      footer={null}
    >
      <Form
        name="clientType"
        initialValues={{
          remember: true,
        }}
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        autoComplete="off"
        form={form}
      >
        {/* Type Name */}
        <Form.Item
          label="Name"
          name="typeName"
          rules={[
            {
              required: true,
              message: <i>{"Please input Name."}</i>,
            },
          ]}
        >
          <Input placeholder="Name" />
        </Form.Item>

        {/* Submit Button */}
        <Form.Item>
          <Button
            loading={loading}
            type="primary"
            htmlType="submit"
            style={{ margin: 2 }}
            className="submitBtn"
          >
            Submit
          </Button>
          {accessRightsToDelete && isForUpdate ? (
            <Popconfirm
              title="Delete the type"
              description="Are you sure to delete?"
              onConfirm={handleClickDelete}
              okText="Yes"
              cancelText="No"
              okButtonProps={{ loading: loading, className: "submitBtn" }}
            >
              <Button loading={loading} type="primary" danger>
                Delete
              </Button>
            </Popconfirm>
          ) : null}
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default CreateUpdateClientType;
